module.exports = __webpack_public_path__ + "static/certinia_logo-8c5b8de0552f31f0f4e396a0c539363e.svg";